export const FigureOrderService = Symbol.for('FigureOrderService');

/**
 * 图形顺序管理服务
 * 负责管理图形的排序和持久化
 */
export interface FigureOrderService {
    /**
     * 重新排序图形
     * @param figureIds 新的图形ID顺序数组
     */
    reorderFigures(figureIds: string[]): Promise<void>;
}
